<template>
  <tr class="border-b-1 border-b-gray-600">
    <th>
      <sort-control
        field="title"
        :selected="currentSortField === 'title'"
        v-on="listeners"
        >Title</sort-control
      >
    </th>
    <th class="hide-mobile">
      System Name
    </th>
    <th class="hide-mobile">
      Description
    </th>
    <th class="hide-mobile">
      Template Type
    </th>
    <th class="actions"></th>
  </tr>
</template>
<script>
import SortControl from "@/components/common/tables/SortControl.vue";

export default {
  components: { SortControl },
  props: ["currentSortField"],
  computed: {
    listeners: function() {
      // Vue 3: $listeners merged into $attrs
      return this.$attrs;
    },
  },
};
</script>
<style lang="scss" scoped>
.actions {
  width: min-content;
}
</style>
